import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">© E-leads {{year}}, All rights reserved</span>
  `,
})
export class FooterComponent {
  year:string;

  ngOnInit() {
    let d = new Date(Date.now());
    this.year = d.getFullYear().toString();
  }
}
